import BotIcon from '../Icons/BotIcon';

const styles = {
  wrap: (size) => ({
    width: size, height: size, borderRadius: '50%',
    overflow: 'hidden', display: 'inline-flex',
    alignItems: 'center', justifyContent: 'center',
    background: 'var(--bg-secondary, #1e1e2e)',
    border: '1.5px solid rgba(139,92,246,0.25)',
    flexShrink: 0,
  }),
  img: { width: '100%', height: '100%', objectFit: 'cover' },
};

/**
 * Small circular bot avatar.
 * Shows the photo if photoUrl is provided, otherwise falls back to BotIcon.
 * size: pixel dimension of the circle (default 24).
 */
export default function BotAvatar({ photoUrl, size = 24, style, title }) {
  return (
    <span style={{ ...styles.wrap(size), ...style }} title={title}>
      {photoUrl
        ? <img src={photoUrl} alt="" style={styles.img} />
        : <BotIcon size={Math.round(size * 0.55)} color="var(--text-secondary, #888)" />}
    </span>
  );
}
